module.exports = __webpack_public_path__ + "assets/img/season3-d578a8ed.png";